/** Holds user global infos. */

import _ from 'lodash'
import Vue from 'vue'

let getUserPropHelper = (prop) => {
  let user = localStorage.getItem('user')
  let v = null
  if (user) {
    v = _.get(JSON.parse(user), prop)
  }
  return v
}

/** initial state */
const state = {
  name: getUserPropHelper('name'),
  username: getUserPropHelper('username'),
  defaultHome: getUserPropHelper('defaultHome'),
  teaMajor:getUserPropHelper('teaMajor'),//教师所属专业
  teaRoleResources:getUserPropHelper('teaRoleResources'),//班主任所带的班级信息
  teaSubjectClasses:getUserPropHelper('teaSubjectClasses'),//多个班级id
  teaSubjects:getUserPropHelper('teaSubjects'),//多个学科id
  teaSubjectGroups:getUserPropHelper('teaSubjectGroups'),//学科专业组
  roleIds: getUserPropHelper('roleIds'),
  token: getUserPropHelper('token'),
  rules: getUserPropHelper('rules'),
  wsUrl: getUserPropHelper('wsUrl'),
  // cookie动态domain
  domain: getUserPropHelper('domain'),
  tClass: false
}

/** actions */
const actions = {
}

/** getters */
const getters = {
  getPath: (state) => (subject) => {
    return _.get(_.find(state.rules, { subject: subject }), 'path')
  }
}

/** mutations */
const mutations = {
  login (state, user) {
    state.name = user.name
    state.username = user.username
    state.defaultHome = user.defaultHome
    state.roleIds = user.roleIds
    state.rules = user.rules
    state.token = user.token
    state.wsUrl = user.wsUrl
    state.domain = user.domain
    Vue.prototype.$ability.update(user.rules)
    console.log(user)
    localStorage.setItem('user', JSON.stringify(user))
  },

  logout (state) {
    state.name = ''
    state.username = ''
    state.defaultHome = ''
    state.roleIds = ''
    state.token = ''
    state.rules = []
    Vue.prototype.$ability.update(state.rules)
    localStorage.removeItem('user')
  },

  setTClass (state, val) {
    state.tClass = val
    localStorage.setItem('tClass', val)
  }
}

/* export for using */
export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/sso/store/modules/user.js